// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import myw from 'myWorld-base';
import pageHtml from 'text!html/phone/phone.html';

const featureLoadingHtml = $(pageHtml)
    .filter('#feature-loading-template')
    .html();

myw.PhoneLayoutFeatureLoadingView = Backbone.View.extend({
    innerTemplate: _.template(featureLoadingHtml),
    className: 'center',
    /*
     * @class  A view for the bar displayed on the map page with the title and short description of the current feature
     * @extends {Backbone.View}
     * @constructs
     */
    initialize() {
        this.render();
    },

    render() {
        this.$el.html(this.innerTemplate());
    }
});

export default myw.PhoneLayoutFeatureLoadingView;
